// @flow
import * as React from 'react';
import { IAuthResponse, IFreeRoom, emptyRoom, sxHistory, sxHistoryValue, sxfw } from '../../Interfaces';
import { useSelector } from 'react-redux';
import { getRoomspace } from '../../Data/ApiRequests';
import { Box, Grid, Typography } from '@mui/material';
import { formattedDateTime } from '../../Helpers/TimeMethods';
type Props = {
    isHistory: boolean,
    wnummer?: string,
    historyRoomspace? : IFreeRoom
};
export const RommspaceInfo = (props: Props) => {
    const { wnummer, historyRoomspace } = {...props};
    const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
    const [roomspace, setRoomspace] = React.useState<IFreeRoom>(emptyRoom)
    const [error, setError] = React.useState('');

    const fetchData = async () => {
        getRoomspace(wnummer, bearerToken.token)
            .then( (response) => {
                // console.log('response', response)
const allRoomsComments = `${response?.text_FeedSlotM || ''}
${response?.text_FeedSlotW || ''}
${response?.text_SingleRoomFMD || ''}
${response?.text_RoomForTwo || ''}
${response?.text_RoomForThree || ''}
${response?.text_RoomForFour || ''}
${response?.text_RoomForFive || ''}
${response?.text_RoomForSix || ''}
${response?.text_RoomForSeven || ''}
${response?.text_RoomForEight || ''}
${response?.text_RoomForNine || ''}
${response?.text_RoomForTen || ''}`
response.allRoomsComments = (allRoomsComments.length > 13) ? allRoomsComments : '-' // 13 -is the velue for all empty lines
response.notesOnAccommodation = (response.notesOnAccommodation === undefined || response.notesOnAccommodation?.length === 0)  ? '-' : response.notesOnAccommodation
                setRoomspace(response)
            }).catch(error => {
                setError('Error.' + error)
            });
    };
    React.useEffect( () => {
        if(historyRoomspace === undefined) {
            fetchData()
        } else {
            historyRoomspace.allRoomsComments= (historyRoomspace.allRoomsComments !== undefined && historyRoomspace.allRoomsComments?.length > 10) ? historyRoomspace.allRoomsComments : '-' // 13 -is the velue for all empty lines
            historyRoomspace.notesOnAccommodation = (historyRoomspace.notesOnAccommodation === undefined || historyRoomspace.notesOnAccommodation?.length === 0)  ? '-' : historyRoomspace.notesOnAccommodation
            setRoomspace(historyRoomspace)
        }
    }, [historyRoomspace]);

    return (
        <div>

{
    roomspace.lastUpdate !== undefined &&
<>
{
    !props.isHistory &&
<h2>Aktuelle Freiplatzmeldung</h2>

}

<Grid container spacing={1}
    sx={{ p: 1, m: 1, border: '#CCC 1px solid', borderRadius: '5px', width: 'calc(100% - 30px)',
    boxShadow: 'rgba(26, 26, 26, 0.16) 0px 2px 8px 0px', boxSizing: 'border-box'}} >
{
    error !== '' && <label className='errorText'>{error}</label>
}
<Grid item xs={12}>
        Aktualisierung um  {formattedDateTime(roomspace.lastUpdate)}</Grid>
        <Grid rowSpacing={1} container sx={{ p: 1, m: 1, border: '#CCC 1px solid', borderRadius: '5px', width: 'calc(100% - 30px)'}}>
            <Grid item xs={4} md={2} sx={{  alignContent: 'center' }}> <Typography sx={sxHistory}>Anzahl Ist-Belegung Ukrainer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.numberOfOccupiedUkr}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl Ist-Belegung örU</Typography></Grid>
            <Grid item xs={2} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.numberOfOccupiedOru}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl belegbare Plätze</Typography></Grid>
            <Grid item xs={2} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.numberOfAvailablePlaces}</Typography></Grid>
            <Grid item xs={4} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl reservierter Plätze</Typography></Grid>
            <Grid item xs={2} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.numberOfReservedSeats}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl nicht belegbarer Plätze</Typography></Grid>
            <Grid item xs={2} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.numberOfUnoccupiedSeats}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistory}>Warum nicht belegbar?</Typography></Grid>
            <Grid item xs={2} md={2} sx={{  alignContent: 'center' }}><Typography sx={sxHistory}>{roomspace.whyNotAssignable}</Typography></Grid>
        </Grid>

        <Grid rowSpacing={1}  container sx={{ p: 1, m: 1, border: '#CCC 1px solid', borderRadius: '5px', width: 'calc(100% - 30px)' }}>

            {/* <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl Einzelzimmer w</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.singleRoomW}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl Einzelzimmer m</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.singleRoomM}</Typography></Grid> */}

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl Einzelzimmer (w/m/d)</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.singleRoomFMD}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl Platz in bereits belegtem Zimmer w</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.feedSlotW}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl Platz in bereits belegtem Zimmer m</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.feedSlotM}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 2er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForTwo}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 3er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForThree}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 4er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForFour}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 5er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForFive}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 6er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForSix}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 7er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForSeven}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 8er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForEight}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 9er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForNine}</Typography></Grid>

            <Grid item xs={4} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistory}>Anzahl 10er Zimmer</Typography></Grid>
            <Grid item xs={2} md={2} sx={{ alignContent: 'center' }}><Typography sx={sxHistoryValue}>{roomspace.roomForTen}</Typography></Grid>


            <Grid item xs={12} md={6}><Typography sx={sxHistory}>Belegungshinweise zu den Plätzen (zusammengeführt je Standort):</Typography>
            <Typography sx={{ ...sxHistoryValue, maxWidth: 'calc(100%-100px)'}} >
                {
                    roomspace.notesOnAccommodation??'-'}
            </Typography></Grid>

            <Grid item xs={12} md={6}><Typography sx={sxHistory}>Allg. Anmerkungen zur Unterbringung</Typography>
                <Typography sx={{ ...sxHistoryValue, maxWidth: 'calc(100%-100px)'}} >{roomspace.allRoomsComments}</Typography>
            </Grid>
        </Grid>
</Grid>
</>
}

{
    (roomspace.lastUpdate === undefined && historyRoomspace === undefined) &&
        <Box sx={sxfw}>Bisher keine Benachrichtigung über freie Plätze eingegangen!</Box>
}

        </div>
    );
};